import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { FarmersRequest } from './dto/farmers.request';
import { SuppliersDTO } from './dto/suppliers.dto';
import { SuppliersService } from './suppliers.service';
import {AllSupplierResponseModel, CommonResponse, FarmerModel, FarmerResponseModel, FarmersDropDownDto, FarmersDropDownResponseModel, FarmersRequestModel, MasterInfoFromIndentResponse, SupplierDTO, SupplierFarmResponse, SupplierResponseModel } from '@gtpl/shared-models/masters';
import { SupplierRequest } from './dto/suppliers.request';
import { SupplierTypeRequest } from './dto/type.request';
import { FarmersModel } from './dto/farmers.model';
import { MasterInfoFromIndentDto } from './dto/master-info-indent.dto';
import { UserRequestDto } from '@gtpl/shared-models/common-models';



@ApiTags('Suppliers')
@Controller('suppliers')
export class SuppliersController {
    constructor(
        private supplierService: SuppliersService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }

    /**
     * creates or updates a value of Suppliers
     * @param EndCustomersDto Suppliers DTO
     * @returns EndCustomersResponse
     */
     @Post('/createSupplier')
     async createSupplier(@Body() supplierDto: SuppliersDTO, isUpdate: boolean = false): Promise<SupplierResponseModel> {
         try {
             return await this.supplierService.createSupplier(supplierDto, false);
         } catch (error) {
             return this.applicationExceptionhandler.returnException(SupplierResponseModel, error)
         }
     }

       /**
     *  creates or updates a value of Suppliers
     * @param EndCustomersDTO 
     * @param request 
     */
    @Post('/updateSupplier')
    async updateSupplier(@Body() supplierDto: SuppliersDTO): Promise<SupplierResponseModel> {
        try {
            return await this.supplierService.createSupplier(supplierDto, true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SupplierResponseModel, error)
        }
    }

    @Post('/getfarmersByBrokerId')
    async getfarmersByBrokerId(@Body() farmerReq: FarmersRequest): Promise<FarmersDropDownDto> {
        try {
            return await this.supplierService.getfarmersByBrokerId(farmerReq);
        } catch (err) {
            throw err;
        }
     }

     @Post('/getfarmers')
     async getfarmers(): Promise<FarmersDropDownResponseModel> {
         try {
             return await this.supplierService.getfarmers();
         } catch (err) {
             throw err;
         }
      }

    @Post('/getAllSuppliers')
    async getAllSuppliers(@Body() req?:UserRequestDto): Promise<AllSupplierResponseModel> {
        try {
            return await this.supplierService.getAllSuppliers(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllSupplierResponseModel, error)
        }
    }
    @Post('/activateorDeactivateSupplier')
    async activateorDeactivateSupplier(@Body() request: SupplierRequest): Promise<SupplierResponseModel> {
        try {
            return await this.supplierService.activateorDeactivateSupplier(request);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(SupplierResponseModel, err);
        }
    }

    @Post('/getFarmersBySupplierType')
    async getFarmersBySupplierType(@Body() supplierType: SupplierTypeRequest): Promise<FarmersDropDownResponseModel> {
        try {
            return await this.supplierService.getFarmersBySupplierType(supplierType);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(FarmersDropDownResponseModel, err);
        }
    }

    @Post('/getFarmCodesBySupplierId')
    async getFarmCodesBySupplierId(@Body() farmerIdReq: FarmersModel): Promise<FarmersDropDownResponseModel> {
        try {
            return await this.supplierService.getFarmCodesBySupplierId(farmerIdReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(FarmersDropDownResponseModel, err);
        }
    }

    @Post('/getSupplierBySupplierId')
    async getSupplierBySupplierId(@Body() supplierIdReq:FarmerModel): Promise<SupplierFarmResponse> {
        try {
            return await this.supplierService.getSupplierBySupplierId(supplierIdReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SupplierFarmResponse, error)
        }
    }

    @Post('/getFarmerDetailsByFarmerId')
    async getFarmerDetailsByFarmerId(@Body() farmerIdReq:FarmerModel): Promise<SupplierFarmResponse> {
        try {
            return await this.supplierService.getFarmerDetailsByFarmerId(farmerIdReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(SupplierFarmResponse, error)
        }
    }


    @Post('/getMastersRelatedDataFromIndent')
    async getMastersRelatedDataFromIndent(@Body() request:MasterInfoFromIndentDto): Promise<MasterInfoFromIndentResponse> {
        try {
            return await this.supplierService.getMastersRelatedDataFromIndent(request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(MasterInfoFromIndentResponse, error)
        }
    }

    @Post('/getFarmersCount')
    async getFarmersCount(): Promise<number> {
        try {
            return await this.supplierService.getFarmersCount();
        } catch (error) {
            return error
        }
    }

    @Post('/getSuppliersByBrokerId')
    async getSuppliersByBrokerId(@Body() brokerReq: FarmersRequest): Promise<FarmersDropDownResponseModel> {
        try {
            return await this.supplierService.getSuppliersByBrokerId(brokerReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(FarmersDropDownResponseModel, err)
        }
     }
     @Post('/createFarmer')
     async createFarmer(@Body() req:FarmersRequestModel):Promise<FarmerResponseModel>{
         try{
             return await this.supplierService.createFarmer(req)
         }catch(err){
             return this.applicationExceptionhandler.returnException(FarmerResponseModel,err)
         }
     }
     @Post('/getAllFarmersInfo')
     async getAllFarmersInfo():Promise<CommonResponse>{
         try{
             return await this.supplierService.getAllFarmersInfo()
         }catch(err){
             return this.applicationExceptionhandler.returnException(CommonResponse,err)
         }
     }
     @Post('/getAllSuppliersNames')
     async getAllSuppliersNames():Promise<CommonResponse>{
         try{
             return await this.supplierService.getAllSuppliersNames()
         }catch(err){
             return this.applicationExceptionhandler.returnException(CommonResponse,err)
         }
     }
     
}
